<template>
	<div class="basis-page-cls">
        <section class="basis-cls_filter">
			<table-search :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" />
        </section>
        <section class="basis-cls_table">
            <div class="header">
                <span class="title el-icon-document"> 数据列表</span>
            </div>
            <div class="table">
				<el-table :data="list" :header-cell-class-name="tableHeaderClassName" :row-style="tableRowClassStyle" ref="table" style="width: 100%;">
					<el-table-column label="账号" prop="ocsAccount" :sortable="$store.getters.userInfo.brandIdentify == brandName" show-overflow-tooltip></el-table-column>
					<el-table-column label="分机号" prop="deviceNumber" :sortable="$store.getters.userInfo.brandIdentify == brandName" show-overflow-tooltip></el-table-column>
					<el-table-column label="开始时间" prop="startTime" :sortable="$store.getters.userInfo.brandIdentify == brandName" show-overflow-tooltip></el-table-column>
					<el-table-column label="应答时间" prop="answerTime" :sortable="$store.getters.userInfo.brandIdentify == brandName" show-overflow-tooltip></el-table-column>
					<el-table-column label="结束时间" prop="endTime" :sortable="$store.getters.userInfo.brandIdentify == brandName" show-overflow-tooltip></el-table-column>
					<el-table-column label="主叫号码" prop="originalCallerIdNumber" :sortable="$store.getters.userInfo.brandIdentify == brandName" show-overflow-tooltip>
						<template slot-scope="scope">
							{{scope.row.callDir == '呼入' ? (isShowPhone ? scope.row.originalCallerIdNumber : hiddenPhone(scope.row.originalCallerIdNumber)) : scope.row.originalCallerIdNumber}}
						</template>
					</el-table-column>
					<el-table-column label="被叫号码" prop="originalDestinationNumber" :sortable="$store.getters.userInfo.brandIdentify == brandName" show-overflow-tooltip>
						<template slot-scope="scope">
							{{scope.row.callDir == '呼出' ? (isShowPhone ? scope.row.originalDestinationNumber : hiddenPhone(scope.row.originalDestinationNumber)) : scope.row.originalDestinationNumber}}
						</template>
					</el-table-column>
					<el-table-column label="技能组" prop="queue" :sortable="$store.getters.userInfo.brandIdentify == brandName" show-overflow-tooltip></el-table-column>
					<el-table-column label="是否接通" prop="connect" :sortable="$store.getters.userInfo.brandIdentify == brandName" show-overflow-tooltip></el-table-column>
					<el-table-column label="通话时长" prop="duration" :sortable="$store.getters.userInfo.brandIdentify == brandName" show-overflow-tooltip></el-table-column>
					<el-table-column label="沟通方向" prop="callDir" :sortable="$store.getters.userInfo.brandIdentify == brandName" show-overflow-tooltip></el-table-column>
					<el-table-column label="录音" width="100">
						<template slot-scope="scope">
							<el-button type="text" :disabled="!scope.row.fileUrl" @click="toogleExpand(scope.row)">录音记录</el-button>
						</template>
					</el-table-column>
					<el-table-column type="expand" width="1">
						<template slot-scope="scope">
							<Record v-if="scope.row.expansion" :auditFilePath="scope.row.fileUrl" />
						</template>
					</el-table-column>
				</el-table>
				<template class="pagination">
					<Pagination 
						:total="total"
						:page.sync="listQuery.pageNumber"
						:limit.sync="listQuery.pageSize"
						@pagination="getList" />
				</template>
            </div>
        </section>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EnumMixin, tableMixin } from "utils/mixins";
import Record from "./media";
import Pagination from 'components/Basis/TablePagination/Pagination';
export default {
	name: 'CommunicatePageIndex',
	mixins: [EnumMixin, tableMixin],
	components: {Record, Pagination},
	computed: {
        ...mapGetters([
			'userInfo',
			'subBrandList',
			'channelList',
			'lark_switch_url',
			'isShowPhone'
        ])
    },
	data() {
		return {
			filterHeader: [
				{ label: '创建时间', model: 'date', type: 'datetimerange', default: '', placeholder: '请选择' },
				// { label: '账号', model: 'ocsAccount', type: 'input', default: '', placeholder: '请输入账号' },
				{ label: '主叫号码', model: 'originalCallerIdNumber', type: 'input', default: '', placeholder: '请输入主叫号码' },
				{ label: '被叫号码', model: 'originalDestinationNumber', type: 'input', default: '', placeholder: '请输入被叫号码' },
				{ label: '沟通方向', model: 'callDir', type: 'radioStyle', default: '', list: [{name: '全部', id: ''}, {name: '来访', id: 'I'}, {name: '出访', id: 'O'}]},
				{ label: '通话类型', model: 'callType  ', type: 'radioStyle', default: '', list: [{name: '全部', id: ''}, {name: '已接', id: '1'}, {name: '未接', id: '0'}]},
			],
			listQuery: {
				pageSize: 10,
                pageNumber: 1,
				projectCode: '',
				date: [new Date(), new Date()],
				date2: '',
				date3: '',
				startTime: '',
				endTime: '',
				ocsAccount: '',
				originalCallerIdNumber: '',
				originalDestinationNumber: '',
				uuid: '',
				callDir: '',
				callType: '',
				deviceNumber: '',
				answerTime: '',
				hangUpTime: ''
            },
			total: 0,
			list: [],
			isChrome: window.navigator.userAgent.indexOf("Chrome") > -1,
			brandName:process.env.VUE_APP_BRANDNAME,
		}
	},
	async created() {
		await this.getList();
		// this.filterHeader[0]['list'] = await this.subBrandList;
		// this.filterHeader[1]['list'] = await this.channelList;
		if(this.userInfo.brandIdentify == this.brandName) {
			this.filterHeader = [
				{ label: '创建时间', model: 'date', type: 'datetimerange', default: '', placeholder: '请选择' },
				{ label: '主叫号码', model: 'originalCallerIdNumber', type: 'input', default: '', placeholder: '请输入主叫号码' },
				{ label: '被叫号码', model: 'originalDestinationNumber', type: 'input', default: '', placeholder: '请输入被叫号码' },
				{ label: '分机号', model: 'deviceNumber', type: 'input', default: '', placeholder: '请输入账号' },
				{ label: '应答时间', model: 'date2', type: 'datetimerange', default: '', placeholder: '请选择' },
				{ label: '结束时间', model: 'date3', type: 'datetimerange', default: '', placeholder: '请选择' },
				{ label: '沟通方向', model: 'callDir', type: 'radioStyle', default: '', list: [{name: '全部', id: ''}, {name: '来访', id: 'I'}, {name: '出访', id: 'O'}]},
				{ label: '通话类型', model: 'callType', type: 'radioStyle', default: '', list: [{name: '全部', id: ''}, {name: '已接', id: '1'}, {name: '未接', id: '0'}]},
			];
		} else {
			this.filterHeader = [
				{ label: '创建时间', model: 'date', type: 'datetimerange', default: '', placeholder: '请选择' },
				{ label: '主叫号码', model: 'originalCallerIdNumber', type: 'input', default: '', placeholder: '请输入主叫号码' },
				{ label: '被叫号码', model: 'originalDestinationNumber', type: 'input', default: '', placeholder: '请输入被叫号码' },
				{ label: '沟通方向', model: 'callDir', type: 'radioStyle', default: '', list: [{name: '全部', id: ''}, {name: '来访', id: 'I'}, {name: '出访', id: 'O'}]},
				{ label: '通话类型', model: 'callType', type: 'radioStyle', default: '', list: [{name: '全部', id: ''}, {name: '已接', id: '1'}, {name: '未接', id: '0'}]},
			];
		}
	},
	methods: {
		getList() {
			this.listQuery.projectCode = this.userInfo.brandIdentify;
			this.listQuery.agent = this.userInfo.agentCode;
			this.listQuery.ocsAccount = this.userInfo.account;
			const arr = this.lark_switch_url ? this.lark_switch_url.split('_') : [];
			this.$api.apiPostRecording(this.listQuery, arr.length > 1 ? ('/lark_' + arr[1]) : ('/lark')).then(response => {
				if(response.errcode != 0) return;
				this.list = response.data ? response.data : [];
				this.list.forEach(val => {
					this.$set(val, "expansion", false);
				});
				this.total = parseInt(response.total);
			});
		},
		handleExport() {
			const arr = this.lark_switch_url ? this.lark_switch_url.split('_') : [];
			this.$api.apiGetRecordingExport(this.listQuery, arr.length > 1 ? ('/lark_' + arr[1]) : ('/lark')).then(response => {
				if(response.errcode != 0) return;
				this.$message.success('已创建任务，请在通知栏查看');
			});
		},
        filterSearch(query) {
			this.listQuery = Object.assign(this.listQuery, query);
            this.getList();
		},
		toogleExpand(row) {
			let $table = this.$refs.table;
			this.list.map(item => {
				if (row.tuid != item.tuid) {
					$table.toggleRowExpansion(item, false);
					item.expansion = false;
				} else {
					item.expansion = !item.expansion;
				}
			});
			$table.toggleRowExpansion(row);
		},
		hiddenPhone(phone) {
			if (!phone) return ''
			return phone.substr(0, 3) + '****' + phone.substr(phone.length - 4);
		},
	}
}
</script>

<style lang="scss" scoped>
::v-deep .pagination-container{
	text-align: center;
}
</style>
